import { useTranslation } from 'react-i18next'
import { Product } from '../../stores/appReportsStore'
import { calculateTotalSpent } from '../../services/import/importProductIdsService'
import { currencyFormatter } from '../../services/helperService'
import { whiteBackgroundClass } from '../../styling/stylingHelper'


interface ComparisonSummaryProps {
  productsMap: Record<string, Product>
  selectedMap: Record<string, Product>
}

export default function ComparisonSummary({ productsMap, selectedMap }: ComparisonSummaryProps) {
  const { t } = useTranslation()

  const currentTotal = Object.values(productsMap).reduce(
    (sum, p: Product) => sum + calculateTotalSpent(p),
    0
  )

  const selectedCount = Object.keys(selectedMap).length
  const newTotal = selectedCount
    ? Object.values(selectedMap).reduce(
        (sum, p: Product) => sum + calculateTotalSpent(p),
        0
      )
    : 0

  const change = selectedCount && currentTotal > 0
    ? ((newTotal - currentTotal) / currentTotal) * 100
    : 0
  const changeFormatted = `${change.toFixed(2)}%`
  const euroChangeFormatted = `${currencyFormatter.format((newTotal - currentTotal) * -1)}`

  const changeClass = change > 0
    ? 'text-textRed dark:text-textRed-dark'
    : change < 0
    ? 'text-textGreen dark:text-textGreen-dark'
    : ''

  return (
    <div className={`flex flex-col lg:flex-row ${selectedCount > 0 ? 'items-center' : 'items-start'} gap-4 mb-6`}>
      {/* current total (always shown) */}
      <div className={`${whiteBackgroundClass} p-4 w-full lg:w-1/3 max-w-[600px] ${selectedCount > 0 ? 'mx-auto' : ''}`}>
        <p className="font-medium text-tertiary dark:text-tertiary-dark">
          {t('sourcing.priceSummary.currentTotal')}
        </p>
        <p className="text-3xl font-semibold text-primary dark:text-primary-dark pt-3">
          {currencyFormatter.format(currentTotal)}
        </p>
      </div>
  
      {selectedCount > 0 && (
        <>
          {/* new total */}
          <div className={`${whiteBackgroundClass} p-4 w-full lg:w-1/3 max-w-[600px] ${selectedCount > 0 ? 'mx-auto' : ''}`}>
            <p className="font-medium text-tertiary dark:text-tertiary-dark">
              {t('sourcing.priceSummary.newTotal')}
            </p>
            <p className="text-3xl font-semibold text-primary dark:text-primary-dark pt-3">
              {currencyFormatter.format(newTotal)}
            </p>
          </div>
  
          {/* change */}
          <div className={`${whiteBackgroundClass} p-4 w-full lg:w-1/3 max-w-[600px] ${selectedCount > 0 ? 'mx-auto' : ''}`}>
            <p className="font-medium text-tertiary dark:text-tertiary-dark">
              {t('sourcing.priceSummary.change')}
            </p>
            <p className="pt-3">
              <span className="text-3xl font-semibold text-primary dark:text-primary-dark">
                {euroChangeFormatted}
              </span>
              <span className={`${changeClass} pl-2`}>{changeFormatted}</span>
            </p>
          </div>
        </>
      )}
    </div>
  ) 
}
